import { Dropdown } from "react-bootstrap";
import DropdownItem from "react-bootstrap/DropdownItem";
import DropdownMenu from "react-bootstrap/DropdownMenu";
import DropdownToggle from "react-bootstrap/DropdownToggle";

import PropTypes from "prop-types";

import CustomTooltip from "../../common/styles/components/tooltip/CustomTooltip";

import { combineClassNames } from "../../utils/appUtils";

import "./WPDropDownMenu.scss";

/* interface IDropdownItem{
    id: string;
    label: string;
    isDisabled: boolean;
    onClick: () => void;
} */

/* 
Note: This dropdown component display (show/hide) is uncontrolled handled by the bootstrap component itself
If required to ovverride the default dropdown props, pass the props as an object in below way
 dropdownProps
 menuProps
 menuItemProps
*/

export const WPDropDownMenu = ({
  id,
  tooltip,
  menuItems,
  toggle,
  children,
  onItemClick,
  autoClose = true,
  disabled = false,
  customClass = "",
}) => (
  <Dropdown
    className={combineClassNames("wp-dropdown-menu-wrapper", customClass)}
    autoClose={autoClose}
  >
    <DropdownToggle
      id={id}
      className="wp-dropdown-toggle"
      variant=""
      disabled={disabled}
    >
      <CustomTooltip text={tooltip} placement="bottom">
        <div>{toggle}</div>
      </CustomTooltip>
    </DropdownToggle>

    <DropdownMenu className="wp-dropdown-menu">
      {menuItems?.map((item, index) => (
        <DropdownItem
          key={index}
          id={item.id}
          name={item.id}
          data-test-id={"menu-item-" + item.id}
          className={combineClassNames(
            "wp-dropdown-item",
            item?.isDisabled && "wp-dropdown-item-disabled"
          )}
          disabled={item.isDisabled}
          onClick={onItemClick || item?.onClick}
        >
          {item.label}
        </DropdownItem>
      ))}
      {children && children}
    </DropdownMenu>
  </Dropdown>
);

WPDropDownMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isDisabled: PropTypes.bool,
      onItemClick: PropTypes.func,
    })
  ),
  toggle: PropTypes.node,
  disabled: PropTypes.bool,
  customClass: PropTypes.string,
};
